<template>
  <div>
    <sc-page-base title="Auditoria de faturas">

      <sc-field>
        <router-link
          class="button is-primary"
          :to="{ name: 'invoice-audit-new' }">Nova fatura</router-link>
      </sc-field>

      <div class="box">
        <sc-field grouped>
          <sc-field
            label="Fatura"
            expanded>
            <sc-input
              type="search"
              v-model="filters.invoiceNumber"
              placeholder="Número da fatura" />
          </sc-field>

          <sc-field
            label="Status"
            expanded>
            <sc-invoice-audit-dropdown-status
              :option-all="true"
              v-model="filters.state" />
          </sc-field>

          <sc-field
            label="Transportadora"
            expanded>
            <sc-logistic-provider-dropdown
              :option-all="true"
              v-model="filters.logisticProviderId" />
          </sc-field>

          <sc-field
            label="Data de criação"
            expanded>
            <sc-range-date-picker
              :format="formartDateToTimestamp"
              v-model="filters.created"/>
          </sc-field>

          <sc-field
            label="Data de vencimento"
            expanded>
            <sc-range-date-picker
              :format="formartDateToTimestamp"
              v-model="filters.due_date"/>
          </sc-field>
        </sc-field>
      </div>

      <div class="box">
        <sc-table
          class="invoice-audit__table"
          :loading="loadingInvoices"
          :data="invoices"
          :paginated="true"
          :backend-pagination="true"
          :total="totalInvoices"
          :per-page="filters.limit"
          :current-page="filters.page"
          @page-change="(page) => filters.page = page"
          @select="selectInvoice">

          <template slot-scope="props">
            <sc-table-column
              field="state_description"
              label="Status"
              :centered="false"
              sortable>
              <sc-invoice-audit-tag-status
                :status="props.row.state" />
            </sc-table-column>

            <sc-table-column
              field="markers"
              label="Marcador"
              :sortable="false">
              <div
                class="tags is-centered"
                v-if="props.row.markers.length > 0">

                <sc-recon-marker
                  v-for="(marker, index) in props.row.markers"
                  :key="index"
                  :marker="marker" />
              </div>
            </sc-table-column>

            <sc-table-column
              field="number"
              label="Fatura"
              sortable>
              {{ props.row.number }}
            </sc-table-column>

            <sc-table-column
              field="divergence"
              label="Divergência"
              sortable>
              {{ props.row.divergence | percent }}
            </sc-table-column>

            <sc-table-column
              field="logistic_provider.name"
              label="Transportadora"
              sortable>
              {{ props.row.logistic_provider.name}}
            </sc-table-column>

            <sc-table-column
              field="created"
              label="Data criação"
              sortable>
              {{ props.row.created | date('DD/MM/YYYY HH:mm') }}
            </sc-table-column>

            <sc-table-column
              field="due_date"
              label="Data vencimento"
              sortable>
              {{ props.row.due_date | date }}
            </sc-table-column>

            <sc-table-column
              field="dueDate"
              label="Arquivos"
              :sortable="false">
              <sc-dropdown
                position="is-bottom-left"
                hoverable>
                <button
                  type="button"
                  class="button"
                  slot="trigger">
                  <span>Opções</span>
                  <sc-icon icon="caret-down"></sc-icon>
                </button>

                <a
                  class="dropdown-item has-text-left"
                  @click.stop="downloadInvoiceFilePerUrl(props.row.cte_url)"
                  v-if="props.row.cte_url">
                  <sc-icon icon="cloud-download-alt" />
                  Baixar arquivo original CT-e
                </a>
                <a
                  class="dropdown-item has-text-left"
                  @click.stop="downloadInvoiceFilePerUrl(props.row.input_url)"
                  v-if="props.row.input_url">
                  <sc-icon icon="cloud-download-alt" />
                  Baixar arquivo original da fatura
                </a>
                <a
                  class="dropdown-item has-text-left"
                  @click.stop="downloadInvoiceFilePerUrl(props.row.result_url)"
                  v-if="props.row.result_url">
                  <sc-icon icon="cloud-download-alt" />
                  Baixar arquivo de análise
                </a>
                <a
                  class="dropdown-item has-text-left"
                  @click.stop="generateAnalyzeFile(props.row.id)"
                  v-if="!props.row.result_url">
                  <sc-icon icon="cloud-download-alt" />
                  Gerar arquivo de análise
                </a>
              </sc-dropdown>
            </sc-table-column>
          </template>

          <template slot="empty">
            <sc-table-empty />
          </template>

          <template slot="bottom-left">
            <sc-table-per-page v-model="filters.limit" />
          </template>

        </sc-table>
      </div>
    </sc-page-base>
    <sc-modal :active.sync="showModal">
      <sc-modal-card>
        <template slot="title">
          <b class="modal-title">Aviso de Migração</b>
        </template>
        <template slot="body">
          <div class="media">
            <div class="media-left">
              <span class="icon has-text-warning is-large">
                  <sc-icon
                    pack="fas"
                    icon="exclamation-circle"
                    size="is-large"
                    type="is-warning">
                  </sc-icon>
              </span>
            </div>
            <div class="media-content">
              <p>O módulo de Auditoria (1.0) foi migrado definitivamente para o módulo 2.0. A realização de novas auditorias deverá ser feita pela aba de "Conciliação de Frete" dentro da plataforma. Nessa nova versão é possível auditar os custos de frete pré-fatura de forma mais automatizada.
Para mais informações e dúvidas sobre o uso da nova versão e seus ajustes de configuração, procure o time Intelipost. </p>
            </div>
          </div>
        </template>
        <template slot="footer">
          <div class="footer-warning">
            <sc-checkbox v-model="disableAviso">Não gostaria de receber este aviso novamente durante a sessão</sc-checkbox>
            <button
              class="button is-warning"
              @click="showModal = false">
                <b>Entendi</b>
            </button>
          </div>
        </template>
      </sc-modal-card>
    </sc-modal>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import {
    ScField,
    ScPageBase,
    ScTable,
    ScTableColumn,
    ScTableEmpty,
    ScTablePerPage,
    ScInput,
    ScIcon,
    ScToast,
    ScDropdown,
    ScDropdownItem,
    ScLogisticProviderDropdown,
    ScRangeDatePicker,
    ScDatepicker,
    ScModalCard,
    ScModal,
    ScCheckbox,
  } from '@intelipost-js/secure-components';
  import { Lodash, Storage } from '@intelipost-js/secure-providers';
  import ScReconMarker from '../../components/sc-recon-marker/ScReconMarker';
  import ScInvoiceAuditTagStatus from './components/sc-invoice-audit-tag-status/ScInvoiceAuditTagStatus';
  import ScInvoiceAuditDropdownStatus from './components/sc-invoice-audit-dropdown-status/ScInvoiceAuditDropdownStatus';

  const { mapState, mapActions } = createNamespacedHelpers('recon/invoiceAudit');

  export default {
    name: 'page-invoice-audit-list',
    data() {
      return {
        showModal: true,
        disableAviso: false,
        filters: Lodash.cloneDeep(this.$store.state.recon.invoiceAudit.filters),
      };
    },
    watch: {
      disableAviso(newValue) {
        Storage.set('disableWarning', newValue);
      },
      filters: {
        handler(newFilters) {
          this.$store.commit('recon/invoiceAudit/setFilters', newFilters);
          this.getInvoices();
        },
        deep: true,
      },
    },
    computed: {
      ...mapState([
        'loadingInvoices',
        'invoices',
        'totalInvoices',
      ]),
    },
    methods: {
      ...mapActions([
        'getInvoices',
        'downloadInvoiceFilePerUrl',
        'generateAnalyzeFile',
      ]),
      selectInvoice({ id }) {
        return this.$router.push({
          name: 'invoice-audit-detail',
          params: { id },
        });
      },
      formartDateToTimestamp(dateRange) {
        return {
          start: new Date(dateRange.start).getTime(),
          end: new Date(dateRange.end).getTime(),
        };
      },
    },
    created() {
      this.getInvoices();
      this.showModal = !Storage.get('disableWarning') || Storage.get('disableWarning') === 'false';
    },
    components: {
      ScField,
      ScPageBase,
      ScTable,
      ScTableColumn,
      ScTableEmpty,
      ScTablePerPage,
      ScInput,
      ScIcon,
      ScToast,
      ScDropdown,
      ScDropdownItem,
      ScReconMarker,
      ScInvoiceAuditTagStatus,
      ScInvoiceAuditDropdownStatus,
      ScLogisticProviderDropdown,
      ScRangeDatePicker,
      ScDatepicker,
      ScModalCard,
      ScModal,
      ScCheckbox,
    },
  };
</script>
<style scoped>
  .footer-warning{
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
</style>


// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/invoice-audit/PageInvoiceAudit.vue